import type {
  ApiTransformationParams,
  IntervalJSON,
} from '@highimpact-frontend/api-types';

export enum DisplayerTypeEnum {
  timeseries,
  rose_wind,
  scatter,
  table,
  histogram,
  ombrothermic,
  tablebycampaign,
}

export enum AxisTypeEnum {
  x,
  y,
  z,
  r,
  theta,
  phi,
  lat,
  lon,
}

export interface AxisType {
  id: number;
  name: string;

  unit: string | null;

  start: number | string | null;
  end: number | string | null;

  scale_type?: 'linear' | 'log' | 'category' | 'multicategory' | 'date' | '-';
}

export interface DisplayerColType {
  name: string;
  requirements: number[];

  axis_id?: number;
  axis_type: AxisTypeEnum;

  link?: number;
}

export interface DisplayerTypeSuccess {
  id: number;

  name: string;
  type: DisplayerTypeEnum;

  manualDataAddition?: boolean; // TODO: determine if this really belongs here

  measures: { [KEY in number]: MeasuresProperty };

  time_range: number[];

  intervals: IntervalJSON[];

  cols: { [KEY in number]: DisplayerColType };
  query_map: { col_id: number; query_col_id: string }[];

  firstRenderDone?: boolean;

  transformations?: ApiTransformationParams['pipeline']['functions'];

  contextIndexToName?: Record<number, string>;

  omitFinalProjection?: boolean;

  preventChangingYaxes?: boolean;

  useOldRequestSchema?: boolean;
}

export interface DisplayerTypeError {
  id: number;
  name: string;
  type: 'DisplayerTypeError';
}

export type DisplayerType = DisplayerTypeSuccess | DisplayerTypeError;

export const isDisplayerTypeSuccess = (
  d: DisplayerType | undefined
): d is DisplayerTypeSuccess =>
  d !== undefined && d.type !== 'DisplayerTypeError';
export const isDisplayerTypeError = (
  d: DisplayerType | undefined
): d is DisplayerTypeError =>
  d !== undefined && d.type === 'DisplayerTypeError';

export const displayerSuccessOrUndefined = (
  d: DisplayerType | undefined
): DisplayerTypeSuccess | undefined =>
  isDisplayerTypeSuccess(d) ? d : undefined;

export interface MeasuresProperty {
  measure_point_id : number;
  measure_type_id: number;
}
